// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.OrientationSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  OrientationSettings component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { map, find } from 'lodash/fp';
import localizer from 'share/localization/Izenda.Localizer';

@observer
export default class OrientationSettings extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func
  };

  static defaultProps = {
    value: 'izNormal'
  };

  renderOption = (data: any) => {
    const onClick = function(value) {
      const { onChange, value: currentValue } = this.props;

      if (onChange && currentValue !== value) {
        onChange({ value: value });
      }
    };

    return (
      <li key={data.name}>
        <a onClick={onClick.bind(this, data.value)} title={data.name}>
          <i className={data.icon} />
          {data.name}
        </a>
      </li>
    );
  }

  renderOptions = (data: Array<any>) => {
    return map(value => this.renderOption(value), data);
  }

  domNode(dom) {
    dom && $izenda(dom).dropdown();
  }

  render() {
    const OPTIONS_CONFIG = [
      { value: 'izNormal', icon: 'icon-text-normal', name: localizer.getText('ORIENTATION_SETTING_NORMAL') },
      {
        value: 'izCounterclockwise',
        icon: 'icon-counter-clockwise',
        name: localizer.getText('ORIENTATION_SETTING_ANGLE_COUNTER')
      },
      { value: 'izClockwise', icon: 'icon-clock-wise', name: localizer.getText('ORIENTATION_SETTING_ANGLE_CLOCKWISE') },
      { value: 'izTextup', icon: 'icon-text-up', name: localizer.getText('ORIENTATION_SETTING_ROTATE_TEXT_UP') },
      { value: 'izTextdown', icon: 'icon-text-down', name: localizer.getText('ORIENTATION_SETTING_ROTATE_TEXT_DOWN') }
    ];

    const currentValue = find({ value: this.props.value }, OPTIONS_CONFIG) || {};
    const icon = currentValue.icon || OPTIONS_CONFIG[0].icon;
    const title = currentValue.name || OPTIONS_CONFIG[0].name;

    return (
      <div className="orientation-setting">
        <i type="button" title={title} className={icon} data-toggle="dropdown" ref={this.domNode} />
        <ul className="dropdown-menu">{this.renderOptions(OPTIONS_CONFIG)}</ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.OrientationSettings.jsx